// @ts-nocheck
import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { containsSpecialChars, getCharacterLimitMessage, getSpecialCharacterMessage, onKeyDown, preventSpecialChars, validateInputRange, validateNumberWithoutDecimal } from "../../../../../../utils/commonFunctions";
import { toast } from "react-toastify";
import { showToastMessage } from "../../../../../../utils/commonFunctions";

const continuousLoadCheckboxStyles = `
  .continuous-load-checkbox .form-check-label {
    margin-top: 5px;
  }
`;
const InputSlider = ({ toggle, openInputSlider, onSelectDevices, userInput, setUserInput, orbitDuration, payloadType }) => {
  // Sync orbitDuration when continuous load is enabled
  const [timeperOrbit, setTimeperOrbit] = useState(null);

  useEffect(() => {
    if (!userInput || userInput?.time_per_orbit === timeperOrbit) return
    setTimeperOrbit(userInput?.time_per_orbit)
  }, [userInput?.atmosData?.uniqueId])


  return (
    <div className={`w-35 h-100 position-absolute top-0 right-0 align-items-start justify-content-end d-flex`} onClick={toggle}>
      <div className={`transition bg-right-slider h-100 w-100 rounded-2`} onClick={(e) => { e.stopPropagation() }}>
        <div className='w-100 d-flex flex-column gap-3'>
          <div className="w-100 d-flex align-items-center justify-content-between ">
            <span className="mb-3 fs-23 w-100 slider-header color-text color-atmos-secondary ps-5">Configure</span>
            <div className='d-flex p-2 rounded cursor-pointer align-items-center justify-content-center bg-blur me-3 hover' onClick={toggle}>
              <i className="fe fe-x fs-23 color-atmos"></i>
            </div>
          </div>
          <Form validated={(userInput?.['time_per_orbit'] === '' || userInput?.['time_per_orbit'] === '0') || userInput?.['AltMeasureAccuracy'] === ''} className="d-flex flex-column gap-3 w-95 ps-5">
            <div className="d-flex flex-column ">
              <Form.Label className="color-text mb-3">Payload Name*</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter payload name"
                value={userInput?.['payloadName']}
                onKeyDown={preventSpecialChars}
                onChange={(event) => {
                  event.preventDefault();
                  const trimmedValue = event.target.value.trimStart();

                  // Block ".", "..", "..."
                  if (/^\.+$/.test(trimmedValue)) {
                    return showToastMessage('info', "Payload Name cannot consist only of dots");
                  }
                  // If the input is valid (less than or equal to 26 characters and no special characters)
                  if (trimmedValue.length <= 26 && !containsSpecialChars(trimmedValue)) {
                    setUserInput({
                      ...userInput,
                      payloadName: trimmedValue
                    });
                    onSelectDevices({
                      ...userInput,
                      payloadName: trimmedValue
                    });
                  }
                  // Allow deletion even if the name was previously longer than 26 characters
                  else if (trimmedValue.length < userInput?.payloadName?.length) {
                    setUserInput({
                      ...userInput,
                      payloadName: trimmedValue
                    });
                    onSelectDevices({
                      ...userInput,
                      payloadName: trimmedValue
                    });
                  }
                  // Show info if the name exceeds 26 characters or contains special characters
                  else {
                    showToastMessage('info', trimmedValue.length > 26 ? getCharacterLimitMessage(26) : getSpecialCharacterMessage())
                  }
                }}
              ></Form.Control>
            </div>
            {/* Continuous Load */}
            {payloadType === 'Earth Observation' && (
              <>
                <style>{continuousLoadCheckboxStyles}</style>
                <div className="d-flex flex-column mt-3">
                  <Form.Check
                    className="continuous-load-checkbox"
                    type="checkbox"
                    label="Continuous Load"
                    checked={userInput?.isContinuousLoad || false}
                    onChange={(e) => {
                      setUserInput({
                        ...userInput,
                        isContinuousLoad: e.target.checked,
                        time_per_orbit: !e.target.checked ? timeperOrbit : orbitDuration,
                      });
                      onSelectDevices({
                        ...userInput,
                        isContinuousLoad: e.target.checked,
                        time_per_orbit: !e.target.checked ? timeperOrbit : orbitDuration,
                      });
                    }}
                    style={{ paddingLeft: "24px" }}
                  />
                </div>
              </>
            )}
            <div className="d-flex flex-column ">
              <Form.Label className="color-text mb-3">Average Active Duration per Orbit (min)*</Form.Label>

              <Form.Control
                required
                step={1}
                min={1}
                max={100}
                type="number"
                placeholder="Enter Duration"
                value={userInput?.["time_per_orbit"]}
                disabled={userInput?.isContinuousLoad}
                onKeyDown={validateNumberWithoutDecimal}
                onChange={(event) => {
                  event.preventDefault();
                  const value: string = event.target.value;
                  const validation = validateInputRange('Average Active Duration per Orbit', value, 1, 100, 3, 'min')
                  if (validation.success) {
                    setUserInput({
                      ...userInput,
                      time_per_orbit: validation.value
                    })
                    onSelectDevices({
                      ...userInput,
                      time_per_orbit: validation.value
                    })
                    setTimeperOrbit(validation.value)
                  } else {
                    showToastMessage('info', validation.error)
                  }
                }}
              ></Form.Control>
              {userInput?.['time_per_orbit'] === '0' && (
                <Form.Control.Feedback type="invalid">
                  Average Active Duration per orbit can not be 0
                </Form.Control.Feedback>
              )}
            </div>
            {/* <div className="d-flex flex-column ">
              <Form.Label className="color-text mb-3">Average Data Generated per second (MB/s)</Form.Label>
              <Form.Control
                as="input"
                required
                step={'any'}
                type="number"
                placeholder="Enter average data generated per second (MB/s)"
                value={userInput?.['downlinkDatasize']}
                onKeyDown={(e) => {
                    if (e.keyCode === 13 || e.keyCode === 69) {
                        e.preventDefault();
                    }
                }}
                onChange={(event) => {
                  event.preventDefault();
                  if (Number(event.target.value) >= 0 && event.target.value.length <= 6) {
                    setUserInput({
                      ...userInput,
                      downlinkDatasize: event.target.value
                    })
                    onSelectDevices({
                      ...userInput,
                      downlinkDatasize: event.target.value
                    })
                  }
                }}
              ></Form.Control>
              <Form.Control.Feedback type="invalid">
                Please enter average data generated per second (MB/s).
              </Form.Control.Feedback>
            </div> */}

            <div className="d-flex flex-column ">
              <Form.Label className="color-text mb-3">Required Pointing Accuracy (deg)*</Form.Label>
              <Form.Control
                required
                type="number"
                step={'any'}
                min={0}
                max={1}
                placeholder="Enter Accuracy"
                value={userInput?.['AltMeasureAccuracy']}
                onKeyDown={onKeyDown}
                onChange={(event) => {
                  event.preventDefault();
                  const value: string = event.target.value;
                  const validation = validateInputRange('Pointing accuracy ', value, 0, 1, 1, '°')
                  if (validation.success) {
                    setUserInput({
                      ...userInput,
                      AltMeasureAccuracy: event.target.value
                    })
                    onSelectDevices({
                      ...userInput,
                      AltMeasureAccuracy: event.target.value
                    })
                  } else {
                    showToastMessage('info', validation.error)
                  }
                }}
              ></Form.Control>
            </div>
          </Form >
        </div >
      </div >
    </div >
  )
}

export default InputSlider